module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "change-company"
  }, [_c('div', {
    staticClass: "container section"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    Skift virksomhed\n                ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n                    Som super admin kan du her ændre hvilken virksomhed du ønsker at se data for. Når du vælger en virksomhed, vil applikationen opdatere og du ser nu de samme data, som virksomhedens egne brugere ser det.\n                ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "24px"
    }
  }, [_vm._v("\n                    Tallet ud for hver virksomhed viser hvor mange svende der har registreret tid inden for de seneste 90 dage.\n                ")]), _vm._v(" "), (_vm.invalidApiKeyCount > 0) ? _c('div', {
    staticClass: "api-warning-banner"
  }, [_c('i', {
    staticClass: "fas fa-exclamation-triangle"
  }), _vm._v("\n                    " + _vm._s(_vm.invalidApiKeyCount) + " virksomhed" + _vm._s(_vm.invalidApiKeyCount === 1 ? '' : 'er') + " med ugyldig API-nøgle\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "filters"
  }, [_c('div', {
    staticClass: "filter-group"
  }, [_c('div', {
    staticClass: "filter-label"
  }, [_vm._v("Sortering")]), _vm._v(" "), _c('button', {
    class: {
      active: _vm.sortBy === 'name'
    },
    on: {
      "click": function($event) {
        _vm.sortBy = 'name'
      }
    }
  }, [_vm._v("Alfabetisk")]), _vm._v(" "), _c('button', {
    class: {
      active: _vm.sortBy === 'svende_desc'
    },
    on: {
      "click": function($event) {
        _vm.sortBy = 'svende_desc'
      }
    }
  }, [_vm._v("Flest svende")]), _vm._v(" "), _c('button', {
    class: {
      active: _vm.sortBy === 'newest'
    },
    on: {
      "click": function($event) {
        _vm.sortBy = 'newest'
      }
    }
  }, [_vm._v("Senest oprettet")])]), _vm._v(" "), _c('div', {
    staticClass: "filter-group"
  }, [_c('div', {
    staticClass: "filter-label"
  }, [_vm._v("System")]), _vm._v(" "), _c('button', {
    class: {
      active: _vm.providerFilter === 'all'
    },
    on: {
      "click": function($event) {
        _vm.providerFilter = 'all'
      }
    }
  }, [_vm._v("Alle")]), _vm._v(" "), _c('button', {
    class: {
      active: _vm.providerFilter === 'Ordrestyring'
    },
    on: {
      "click": function($event) {
        _vm.providerFilter = 'Ordrestyring'
      }
    }
  }, [_vm._v("Ordrestyring")]), _vm._v(" "), _c('button', {
    class: {
      active: _vm.providerFilter === 'Minuba'
    },
    on: {
      "click": function($event) {
        _vm.providerFilter = 'Minuba'
      }
    }
  }, [_vm._v("Minuba")])]), _vm._v(" "), _c('div', {
    staticClass: "filter-group"
  }, [_c('div', {
    staticClass: "filter-label"
  }, [_vm._v("Svende")]), _vm._v(" "), _c('button', {
    class: {
      active: _vm.svendeFilter === 'all'
    },
    on: {
      "click": function($event) {
        _vm.svendeFilter = 'all'
      }
    }
  }, [_vm._v("Alle")]), _vm._v(" "), _c('button', {
    class: {
      active: _vm.svendeFilter === 'with'
    },
    on: {
      "click": function($event) {
        _vm.svendeFilter = 'with'
      }
    }
  }, [_vm._v("Med svende")]), _vm._v(" "), _c('button', {
    class: {
      active: _vm.svendeFilter === 'without'
    },
    on: {
      "click": function($event) {
        _vm.svendeFilter = 'without'
      }
    }
  }, [_vm._v("Uden svende")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, [(_vm.loading) ? _c('box-loading', {
    attrs: {
      "height": "350"
    }
  }) : [(_vm.filteredCompanies.length === 0) ? _c('div', {
    staticStyle: {
      "color": "#666",
      "padding": "20px"
    }
  }, [_vm._v("\n                        Ingen virksomheder matcher filtrene.\n                    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredCompanies), function(company) {
    return _c('div', {
      key: company.uuid,
      staticClass: "company"
    }, [_c('div', {
      staticClass: "name"
    }, [(company.api_key_status === 'invalid') ? _c('span', {
      staticClass: "api-warning",
      attrs: {
        "title": 'Ugyldig API-nøgle: ' + (company.api_key_check_error || '?')
      }
    }, [_c('i', {
      staticClass: "fas fa-exclamation-triangle"
    })]) : _vm._e(), _vm._v("\n                            " + _vm._s(company.name) + "\n                            "), _c('br'), _vm._v(" "), (company.api_provider.name === 'Ordrestyring') ? _c('span', {
      staticStyle: {
        "background": "#339861",
        "color": "#fff",
        "font-size": "12px",
        "padding": "2px 6px",
        "margin-top": "4px",
        "display": "inline-block",
        "border-radius": "3px"
      }
    }, [_vm._v("\n                                " + _vm._s(company.api_provider.name) + "\n                            ")]) : _c('span', {
      staticStyle: {
        "background": "#852240",
        "color": "#fff",
        "font-size": "12px",
        "padding": "2px 6px",
        "margin-top": "4px",
        "display": "inline-block",
        "border-radius": "3px"
      }
    }, [_vm._v("\n                                " + _vm._s(company.api_provider.name) + "\n                            ")]), _vm._v(" "), (company.active_field_employees_90d > 0) ? _c('span', {
      staticClass: "svende-badge",
      attrs: {
        "title": 'Aktive svende (working_field=1) der har registreret tid de seneste 90 dage'
      }
    }, [_c('i', {
      staticClass: "fas fa-user-hard-hat"
    }), _vm._v(" " + _vm._s(company.active_field_employees_90d) + "\n                            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "action",
      on: {
        "click": function($event) {
          return _vm.changeCompany(company)
        }
      }
    }, [_vm._v("\n                            Skift til denne virksomhed\n                            "), _c('i', {
      staticClass: "fas fa-arrow-right"
    })])])
  })]], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db2305ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/components/changeCompany.vue
// module id = 936
// module chunks = 0